import * as React from "react";
import { useState, useEffect, useRef } from "react";

export default function CreateCollectionButton({
  className,
  onClick,
}: {
  className: string;
  onClick?: () => void;
}) {
  const [isBlinking, setIsBlinking] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const startBlink = () => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(() => {});
      }
      setIsBlinking(true);
      setTimeout(() => setIsBlinking(false), 700);
    };

    const getRandomInterval = () =>
      Math.floor(Math.random() * (7000 - 5000) + 5000);

    const scheduleNextBlink = () => {
      const nextInterval = getRandomInterval();
      return setTimeout(() => {
        startBlink();
        timer = scheduleNextBlink();
      }, nextInterval);
    };

    let timer = scheduleNextBlink();

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div
      onClick={onClick}
      className={`${className} left-1/2 -translate-x-1/2 -translate-y-1/2 aspect-square bg-transparent flex items-center justify-center relative hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out`}
    >
      <img
        src="/assets/create-collection-button.svg"
        alt="Create Collection"
        className="w-full h-full"
      />

      <video
        ref={videoRef}
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 transition-opacity duration-200 ${isBlinking ? "opacity-100" : "opacity-0"}`}
        autoPlay
        muted
        playsInline
        style={{
          mixBlendMode: "screen",
          width: "calc(100% - 20px)",
          height: "calc(100% - 20px)",
        }}
      >
        <source
          src="/assets/create_collection_button_blink.mp4"
          type="video/mp4"
        />
      </video>

      <div className="font-silkscreen flex flex-col text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20">
        <p className="text-[32px]">CREATE</p>
        <p className="text-[19px]">COLLECTION</p>
      </div>
    </div>
  );
}
